import _ from 'lodash';
export function cleanPayload<T>(payload: T, isVisible: (field: string) => boolean): T {
    return (_.omitBy(payload as any, (value, field) => !isVisible(field)) as unknown) as T;
}
